import type { Expense } from '@otw/models'

export interface RepairShopInvoiceImportInput {
  storagePath: string
  repairTruckId: string
  vehicleId: string | null
  repairShopId: string | null
  note?: string
}

export function findExpenseByRepairInvoicePath(
  expenses: Expense[],
  storagePath: string,
): Expense | undefined {
  return expenses.find(expense => expense.sourceRepairInvoiceStoragePath === storagePath)
}
